import { useQuery } from '@tanstack/react-query';
import api from '../utils/axios.ts';

export function usePaybillBalance() {
  const {
    data,
    isLoading,
    error,
    refetch,
    isFetching
  } = useQuery({
    queryKey: ['paybill-balance'],
    queryFn: async () => {
      const response = await api.get('/paybill/balance');
      return response.data;
    },
    enabled: false, // Only fetch when refetch is called
    retry: 1,
  });

  return {
    balance: data?.balance ?? null,
    currency: data?.currency ?? 'KES',
    message: data?.message ?? '',
    isLoading,
    isFetching,
    error: error as any,
    refetch,
    success: data?.success ?? false,
  };
} 